import { render, staticRenderFns } from "./copergelenfatura.vue?vue&type=template&id=56b8bbb7&scoped=true&"
import script from "./copergelenfatura.vue?vue&type=script&lang=js&"
export * from "./copergelenfatura.vue?vue&type=script&lang=js&"
import style0 from "./copergelenfatura.vue?vue&type=style&index=0&id=56b8bbb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8bbb7",
  null
  
)

export default component.exports